import React, { useState } from 'react';
import style from './preview-content.module.scss';
import { DeleteIcon } from '../../../../../chat/icons';
import lodash from "lodash";

// icons
import TextIcon from '../../../../../../../../assets/svg/solo-chat/content-types/text.svg';
import SimpleChoiceIcon from '../../../../../../../../assets/svg/solo-chat/content-types/simple-choice.svg';
import CardChoiceIcon from '../../../../../../../../assets/svg/solo-chat/content-types/card-choice.svg';
import AutocompleteIcon from '../../../../../../../../assets/svg/solo-chat/content-types/autocomplete.svg';
import ImageIcon from '../../../../../../../../assets/svg/solo-chat/content-types/image.svg';
import MarkdownIcon from '../../../../../../../../assets/svg/solo-chat/content-types/markdown.svg';
import PdfIcon from '../../../../../../../../assets/svg/solo-chat/content-types/pdf.svg';
import AdaptiveCardIcon from '../../../../../../../../assets/svg/solo-chat/content-types/adaptive-card.svg';
import CarouselIcon from '../../../../../../../../assets/svg/solo-chat/content-types/carousel.svg';
import { AddContent } from '../../../../../soloJourney/properties/message/components/AddContent';
import { ContentValue } from '../../../content/types';

type Props = {
	remove: () => void;
	contentId: string
	contentType: string
	title: string
	contentValue: ContentValue & { id: string }
	headless?: boolean
};

export function PreviewContent(props: Props) {
	const { title, remove, contentType, contentValue: content, headless = false } = props;
	const [isOpen, setIsOpen] = useState(false)
	let initialValue = content as any

	if(initialValue.style) {
		initialValue = { ...initialValue, ...initialValue.style }
		delete initialValue.style
	}

	if(contentType === 'autoComplete' && initialValue.options) {
		initialValue.choices = initialValue.options.map((el: any) => ({
			id: el.id,
			label: el.label,
		}))
	}

	return (
		<div role="button" data-headless={headless} className={style.previewContent} onClick={() => {
				setIsOpen(true)
		}}>
			<div style={{ overflow: "hidden" }} title={lodash.startCase(contentType)}>
				<img src={iconMap[contentType]} alt="preview content" />
				<p>{title}</p>
			</div>
			<div data-open={isOpen}>
				<button onClick={remove}>
					<DeleteIcon width="14" height="14" stroke="#292D32" />
				</button>
			</div>
			{isOpen && (
				<AddContent 
					contentType={contentType} 
					refetchContent={() => {}}
					close={() => setIsOpen(false)}
					isOpen={isOpen}
					onCreate={() => {}}
					mode="view"
					initialValue={initialValue}
					isPreview
				/>
			)}
		</div>
	);
}

const iconMap: Record<string, string> = {
	text: TextIcon,
	simpleChoice: SimpleChoiceIcon,
	cardChoice: CardChoiceIcon,
	pdf: PdfIcon,
	image: ImageIcon,
	autoComplete: AutocompleteIcon,
	adaptiveCard: AdaptiveCardIcon,
	markdown: MarkdownIcon,
	cardCarousel: CarouselIcon,
}
